'use client';

import { createContext, FC, ReactNode, useMemo } from 'react';
import { RequestNode } from 'generated/types';

interface IMagicSearchContext {
  suggestions: RequestNode[];
}

interface IMagicSearchProvider {
  suggestions: RequestNode[];
  children: ReactNode;
}

const defaultValues: IMagicSearchContext = {
  suggestions: [],
};

const MagicSearchContext = createContext(defaultValues);

export const MagicSearchProvider: FC<IMagicSearchProvider> = (props) => {
  const { children, suggestions } = props;

  const value: IMagicSearchContext = useMemo(() => ({
    suggestions,
  }), [suggestions]);

  return (
    <MagicSearchContext.Provider value={value}>
      {children}
    </MagicSearchContext.Provider>
  );
};

export default MagicSearchContext;
